export class AddressQueryParameters {
  associateId?: string;
  countryId?: string;
  countyId?: string;
  embed?: Array<string>;
  locationId?: string;
  page?: number;
  pageSize?: number;
  phoneNumber?: string;
  postalZipCode?: string;
  provStateId?: string;
  sequence?: number;

  constructor(obj?: AddressQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
